import { render, staticRenderFns } from "./ResultsHeader.vue?vue&type=template&id=52f18310&scoped=true"
import script from "./ResultsHeader.vue?vue&type=script&lang=js"
export * from "./ResultsHeader.vue?vue&type=script&lang=js"
import style0 from "./ResultsHeader.vue?vue&type=style&index=0&id=52f18310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f18310",
  null
  
)

export default component.exports